import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "wrh-input-label mb-2"
}, "Type your Old Password", -1)
const _hoisted_3 = { class: "text-wrh-gray-dark relative" }
const _hoisted_4 = ["type", "disabled"]
const _hoisted_5 = {
  key: 2,
  class: "wrh-error password-error"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "wrh-input-label mb-2" }, "Create New Password", -1)
const _hoisted_7 = { class: "text-wrh-gray-dark relative" }
const _hoisted_8 = ["type", "disabled"]
const _hoisted_9 = {
  key: 2,
  class: "wrh-error"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "wrh-input-label mb-2" }, "Confirm New Password", -1)
const _hoisted_11 = { class: "text-wrh-gray-dark relative" }
const _hoisted_12 = ["type", "disabled"]
const _hoisted_13 = {
  key: 2,
  class: "wrh-error"
}
const _hoisted_14 = {
  key: 3,
  class: "wrh-error relative validation-error"
}
const _hoisted_15 = { class: "pt-2 text-right" }
const _hoisted_16 = ["disabled"]

import {
  ref, PropType, toRefs, computed,
} from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getAuth, User } from 'firebase/auth';
import { handlePasswordSet, reAuthenticateAndUpdate, updateBuyerVerification } from '../services/service';
import { checkRequireField, validatePassword } from '@/util/validation';
import {
  ValidationMessages, Response, Routes, FirebaseErrors, HomeBuyer,
} from '@/constants';
import { Homebuyer } from '@/models';
import ShowPassword from '@/components/icons/ShowPasswordIcon.vue';
import HidePassword from '@/components/icons/HidePasswordIcon.vue';
import { checkStringEquality, showLoader } from '@/util/funcs';

type Password = 'currentPassword' | 'newPassword' | 'confirmPassword';

export default /*#__PURE__*/_defineComponent({
  props: {
  homeBuyer: {
    type: Object as PropType<Homebuyer>,
    required: true,
  },
},
  emits: ['showAlert'],
  setup(__props, { emit }) {

const props = __props


const { homeBuyer } = toRefs(props);
const store = useStore();
const errors = ref<Record<string, unknown>>({});
const loading = ref(false);
const router = useRouter();

const isAdmin = computed(() => !store.getters.isLoginAsAdmin);
const password = ref({
  currentPassword: '',
  newPassword: '',
  confirmPassword: '',
});
const isVisiblePassword = ref({
  currentPassword: false,
  newPassword: false,
  confirmPassword: false,
});

const isAdditionalUser = computed(() => {
  const buyer = store.getters.homebuyer;
  return checkStringEquality(buyer.buyerType, HomeBuyer.ADDITIONAL_USER);
});

const isUserVerified = computed(() => {
  const buyer = store.getters.homebuyer;
  return !!buyer.userVerified;
});

const isEmptyPassword = (data: string, fieldName: string) => {
  const message = checkRequireField(data, fieldName);
  if (message) {
    errors.value[fieldName.split(' ').join('').toLowerCase()] = message;
  }
};

const isValidPassword = () => {
  if (password.value.confirmPassword !== password.value.newPassword) {
    errors.value.validation = ValidationMessages.PasswordMismatchError;
  } else if (Object.values(password.value).every((x) => x === password.value.currentPassword)) {
    errors.value.validation = ValidationMessages.SamePasswordError;
  } else {
    const error = password.value.newPassword && validatePassword(password.value.newPassword, homeBuyer.value.email, homeBuyer.value.firstName, homeBuyer.value.lastName);
    if (error.length) {
      errors.value.validation = ValidationMessages.InvalidPasswordError;
    }
  }
};

const validatePasswords = () => {
  isEmptyPassword(password.value.currentPassword, 'Old Password');
  isEmptyPassword(password.value.newPassword, 'New Password');
  isEmptyPassword(password.value.confirmPassword, 'Confirm Password');
  if (password.value.newPassword && password.value.confirmPassword) {
    isValidPassword();
  }
};

const updateEmailVerified = async (user: User) => {
  loading.value = false;
  if (isAdditionalUser.value && !isUserVerified.value) {
    await updateBuyerVerification(user.email as string);
  }
  user.reload().then(() => {
    // router.push({ name: Routes.DASHBOARD });
    window.location.href = window.location.origin;
  }).catch((err) => {
    router.push({ name: Routes.LOGIN });
  });
};

const showModal = (modalType: Response) => {
  emit('showAlert', modalType);
};

const submitRequest = async () => {
  showLoader(true);
  errors.value = {};
  validatePasswords();
  if (!Object.keys(errors.value).length) {
    const user = getAuth().currentUser;
    if (user && user.email) {
      loading.value = true;
      try {
        await reAuthenticateAndUpdate(user, user.email, password.value.currentPassword, password.value.newPassword);
        handlePasswordSet(updateEmailVerified, showModal);
      } catch (err: any) {
        if (err.code && err.code === FirebaseErrors.InvalidPassword) {
          errors.value.validation = ValidationMessages.InvalidOldPassword;
        } else {
          showModal(Response.ERROR);
        }
      }
      loading.value = false;
    } else {
      loading.value = false;
      showLoader(false);
      router.push({ name: Routes.LOGIN });
    }
  }
  showLoader(false);
};

const togglePasswordEye = (passwordType: Password) => {
  isVisiblePassword.value[passwordType] = !isVisiblePassword.value[passwordType];
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submitRequest, ["prevent"]),
    class: "lg:w-1/2 space-y-6"
  }, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: isVisiblePassword.value.currentPassword ? 'text' : 'password',
          id: "oldPass",
          class: _normalizeClass(['wrh-input border-wrh-gray-dark', {'border-red-600': Object.keys(errors.value).length && errors.value.oldpassword}]),
          placeholder: "Old Password",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (password.value.currentPassword = $event)),
          disabled: !_unref(isAdmin)
        }, null, 10, _hoisted_4), [
          [_vModelDynamic, password.value.currentPassword]
        ]),
        (!isVisiblePassword.value.currentPassword)
          ? (_openBlock(), _createBlock(HidePassword, {
              key: 0,
              class: "bg-white w-5 h-5 absolute right-[15px] top-[11px] cursor-pointer text-wrh-gray-light",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (togglePasswordEye('currentPassword')))
            }))
          : (_openBlock(), _createBlock(ShowPassword, {
              key: 1,
              class: "bg-white w-5 h-5 absolute right-[15px] top-[11px] cursor-pointer text-wrh-gray-light",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (togglePasswordEye('currentPassword')))
            })),
        (Object.keys(errors.value).length && errors.value.oldpassword)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(errors.value.oldpassword), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: isVisiblePassword.value.newPassword ? 'text' : 'password',
          id: "newPassword",
          class: _normalizeClass(['wrh-input border-wrh-gray-dark', {'border-red-600': Object.keys(errors.value).length && errors.value.newpassword}]),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (password.value.newPassword = $event)),
          placeholder: "New Password",
          disabled: !_unref(isAdmin)
        }, null, 10, _hoisted_8), [
          [_vModelDynamic, password.value.newPassword]
        ]),
        (!isVisiblePassword.value.newPassword)
          ? (_openBlock(), _createBlock(HidePassword, {
              key: 0,
              class: "bg-white w-5 h-5 absolute right-[15px] top-[11px] cursor-pointer text-wrh-gray-light",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (togglePasswordEye('newPassword')))
            }))
          : (_openBlock(), _createBlock(ShowPassword, {
              key: 1,
              class: "bg-white w-5 h-5 absolute right-[15px] top-[11px] cursor-pointer text-wrh-gray-light",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (togglePasswordEye('newPassword')))
            })),
        (Object.keys(errors.value).length && errors.value.newpassword)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(errors.value.newpassword), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("input", {
          type: isVisiblePassword.value.confirmPassword ? 'text' : 'password',
          id: "confirmPassword",
          class: _normalizeClass(['wrh-input border-wrh-gray-dark', {'border-red-600': Object.keys(errors.value).length && errors.value.confirmpassword}]),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (password.value.confirmPassword = $event)),
          placeholder: "Confirm New Password",
          disabled: !_unref(isAdmin)
        }, null, 10, _hoisted_12), [
          [_vModelDynamic, password.value.confirmPassword]
        ]),
        (!isVisiblePassword.value.confirmPassword)
          ? (_openBlock(), _createBlock(HidePassword, {
              key: 0,
              class: "bg-white w-5 h-5 absolute right-[15px] top-[11px] cursor-pointer text-wrh-gray-light",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (togglePasswordEye('confirmPassword')))
            }))
          : (_openBlock(), _createBlock(ShowPassword, {
              key: 1,
              class: "bg-white w-5 h-5 absolute right-[15px] top-[11px] cursor-pointer text-wrh-gray-light",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (togglePasswordEye('confirmPassword')))
            })),
        (Object.keys(errors.value).length && errors.value.confirmpassword)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(errors.value.confirmpassword), 1))
          : _createCommentVNode("", true),
        (Object.keys(errors.value).length && errors.value.validation)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(errors.value.validation), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        class: _normalizeClass([
          'btn w-full md:w-36 bg-wrh-blue-light text-white rounded uppercase py-2 hover:bg-wrh-blue-600 focus:outline-none transition-colors duration-300 ease-in-out',
          {'cursor-not-allowed': loading.value }
        ]),
        disabled: !_unref(isAdmin)
      }, " Save ", 10, _hoisted_16)
    ])
  ], 40, _hoisted_1))
}
}

})